export default __webpack_public_path__ + "static/media/STRIP-LogoBGVer.c5598787.png";